/**
 * useDiscoverCategories (web) — backend-driven Discover/Book tiles via React
 * Query. staleTime 24h (the TTL); bundled fallback as placeholder + on error
 * so chips are never empty. Mirrors the RN hook (which uses MMKV SWR).
 */
import { useQuery } from '@tanstack/react-query';

import { catalogApi } from '../api/catalogApi';
import { BUNDLED_DISCOVER_CATEGORIES } from '../utils/discoverCategories';
import type { CatalogCategory } from '@wg/types';

const DAY_MS = 24 * 60 * 60 * 1000;

export function useDiscoverCategories(destination?: string): {
  categories: CatalogCategory[];
  loading: boolean;
} {
  const { data, isLoading } = useQuery<CatalogCategory[]>({
    queryKey: ['discover-categories', destination ?? 'global'],
    queryFn: () => catalogApi.getCategories(destination),
    staleTime: DAY_MS,
    retry: 1,
    placeholderData: BUNDLED_DISCOVER_CATEGORIES,
  });

  const categories =
    data && data.length > 0 ? data : BUNDLED_DISCOVER_CATEGORIES;
  return { categories, loading: isLoading };
}

export default useDiscoverCategories;
